import React, { useState } from 'react';
import { DocumentDuplicateIcon, CheckIcon } from '@heroicons/react/24/outline';

const InviteLink = ({ venueShortCode }) => {
    const [copied, setCopied] = useState(false);

    const generateInviteLink = (venueShortCode) => {
        const baseUrl = window.location.origin;
        return `${baseUrl}/signup/venue/${venueShortCode}`;
    };

    const inviteLink = generateInviteLink(venueShortCode);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inviteLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <div className="backdrop-blur-sm bg-gray-900/20 border border-gray-700/30 rounded-xl p-6 hover:bg-gray-900/30 transition-all duration-300">
            <h3 className="text-lg font-semibold text-white mb-2">Invite Link</h3>
            <p className="text-sm text-amber-400 mb-4 flex items-start space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span>Please ensure you have set your terms and conditions before sending this link to users.</span>
            </p>
            
            <div className="space-y-4">
                <div className="relative">
                    <input
                        type="text"
                        value={inviteLink}
                        readOnly
                        className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600/50 rounded-lg text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-400 pr-12"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                        <button
                            onClick={handleCopy}
                            className="p-1 text-gray-400 hover:text-emerald-400 transition-colors duration-200"
                            title="Copy to clipboard"
                        >
                            {copied ? (
                                <CheckIcon className="h-5 w-5 text-emerald-400" />
                            ) : (
                                <DocumentDuplicateIcon className="h-5 w-5" />
                            )}
                        </button>
                    </div>
                </div>
                
                <button
                    onClick={handleCopy}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500/50"
                >
                    {copied ? (
                        <>
                            <CheckIcon className="h-5 w-5" />
                            <span>Copied!</span>
                        </>
                    ) : (
                        <>
                            <DocumentDuplicateIcon className="h-5 w-5" />
                            <span>Copy Link</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default InviteLink;
